module.exports = __webpack_public_path__ + "img/ArrowDown.b61741e9.png";